import { productImageCarouselStyles } from "@insite/content-library/Components/ProductImageCarousel";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

Object.assign(productImageCarouselStyles, {
    ...productImageCarouselStyles,
    carouselSlideInner: {
        css: css`
            width: 100%;
            text-align: center;
            position: relative;
            padding: 10px 3px 0;
            display: flex;
            justify-content: center;

            [class^="StyledButton"] {
                width: 45px;
                height: 45px;
            }
        `,
    },
});
